import React from "react";
import HeaderComponent from "../components/UI/HeaderComponent";
import SidePanel from "../components/UI/SidePanel";
import ReferenceDataComponent from "../components/ReferenceDataComponent";

const ReferenceDataPage = () => {
  return (
    <div>
      <HeaderComponent  visibility={true}/>
      <div className="sidebar">
        <SidePanel />
      </div>
      <ReferenceDataComponent />
    </div>
  );
};

export default ReferenceDataPage;
